import React from "react";
import CollapsibleCardHeader from "../../../../components/atoms/cardHeader/collapsibleCardHeader";
import media from "../../../../media";
import { useParams } from "react-router-dom";
import CompositionDetail from "../../../Catalog/addProductToInventory/ProductPreview/components/CompositionDetail";

const ProductDetails = ({ data }) => {
  const {base} = useParams();
  const detail = data?.productDetails;

  return (
    <>
      <div className="card">
        <CollapsibleCardHeader name="Product Details" target="collapseOne" />
        <div
          id="collapseOne"
          className="collapse"
          data-parent="#vender_product_preview"
        >
          <div className="card-body overflow-hidden">
            <div className="overflow-hidden product_type">
              <div className="align-items-center d-flex float-lg-left mb-3 w-100">
                <span className="font-size-lg font-weight-boldest m-0">
                  Brand Name :
                </span>
                <span className="font-size-md ml-5">
                  {detail?.brand?.name?.en}
                </span>
              </div>

              <div className="align-items-center d-flex float-lg-left mb-3 w-100">
                <span className="font-size-lg font-weight-boldest m-0">
                  Product Category :
                </span>
                <span className="font-size-md ml-5">
                  {detail?.productDomain?.en} -{" "}
                  {detail?.productParentCategory?.en}
                </span>
              </div>
              <div className="align-items-center d-flex float-lg-left mb-3 w-100">
                <span className="font-size-lg font-weight-boldest m-0">
                  Brand Logo :
                </span>
                <img
                  src={
                    detail?.brand?.image ? detail?.brand?.image : media.Default
                  }
                  alt="Brand Logo"
                  className=" ml-5 max-w-100px"
                />
              </div>
            </div>

            {/**Composition Start**/}
           
              <CompositionDetail productbase={base} detail={data}/>
           
            {/**Composition End**/}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductDetails;
